import { connect } from 'react-redux'

export default (InnerComponent = null, action, id) =>
  connect(() => ({ action, id }))(InnerComponent)
